import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { IDeviceTable } from '@/api/routes/devices/types';
import type { ResponseWithPagination } from '@/utils/types';

import { fetchDevicesTable } from './actionCreators';

interface InitialState {
  devicesTable: IDeviceTable [],
  isLoading: boolean,
  offset: number,
  totalCount: number,
  error: string,
}

const initialState: InitialState = {
  devicesTable: [],
  offset: 0,
  totalCount: 0,
  isLoading: false,
  error: '',
};

export const devicesTableSlice = createSlice({
  name: 'devicesTable',
  initialState,
  reducers: {
    addDeviceTable: (state, action: PayloadAction<IDeviceTable>) => {
      state.devicesTable = [action.payload, ...state.devicesTable];
    },
    updateDeviceTable: (state, action: PayloadAction<IDeviceTable>) => {
      const deviceIndex = state.devicesTable.findIndex((el) => el.id === action.payload.id);
      state.devicesTable[deviceIndex] = action.payload;
    },
    deleteDeviceTable: (state, action: PayloadAction<IDeviceTable>) => {
      state.devicesTable = state.devicesTable.filter((device) => device.id !== action.payload.id);
    },
  },
  extraReducers: {
    [fetchDevicesTable.fulfilled.type]: (state, action: PayloadAction<ResponseWithPagination<IDeviceTable>>) => {
      state.isLoading = false;
      state.error = '';
      state.devicesTable = action.payload.rows;
      state.offset = action.payload.offset;
      state.totalCount = action.payload.total_count;
    },
    [fetchDevicesTable.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchDevicesTable.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  updateDeviceTable,
  deleteDeviceTable,
  addDeviceTable,
} = devicesTableSlice.actions;

export default devicesTableSlice.reducer;
